import { SHIPMENT_TYPE } from './ContainerUtils';
import { CardData } from './Interfaces/Shipment.interface';
import { BulkApiRequest } from './Interfaces/TypesInShipmentTracking';

function getShipmentType(type: string): string {
  switch (type) {
    case 'BL': return 'bl';
    case 'CN': return 'containers';
    default: return type;
  }
}

function getCardType(tabId: string, cardData: CardData): string {
  switch (tabId) {
    case SHIPMENT_TYPE.CONTAINER: return SHIPMENT_TYPE.CN;
    case SHIPMENT_TYPE.BL: return cardData.trackingType || SHIPMENT_TYPE.BL;
    default: return cardData.trackingType || cardData.shipmentType || cardData.resourceType;
  }
}

function getBulkRequestArray(shipments: CardData[], tabId: string): BulkApiRequest[] {
  const bulkRequestBody = shipments.map((shipment: CardData) => ({
    shipmentId: shipment.shipmentId || shipment.id,
    shipmentType: getCardType(tabId, shipment),
  }));
  return bulkRequestBody;
}
function getShipmentIdArray(shipments: CardData[], tabId: string): string[] {
  const bulkRequestBody = shipments.map((shipment: CardData) => (shipment.id || shipment.shipmentId));
  return bulkRequestBody;
}

const getShipmentNumber = (cardData) => {
  const {
    shipmentNumber,
    containerNumber,
    blNumber,
    hblNumber,
    bookingNumber,
  } = cardData;

  if (cardData?.trackingType === SHIPMENT_TYPE.HBL) {
    return `(HBL# ${hblNumber || shipmentNumber})`;
  }
  switch (cardData.shipmentType) {
    case SHIPMENT_TYPE.BK: return `(BK# ${bookingNumber || shipmentNumber})`;
    case SHIPMENT_TYPE.BL: return `(BL# ${blNumber || shipmentNumber})`;
    case SHIPMENT_TYPE.HBL: return `(HBL# ${hblNumber || shipmentNumber})`;
    case SHIPMENT_TYPE.CN: return `(CN# ${containerNumber || shipmentNumber})`;
    default: {
      if (containerNumber) return `(CN# ${containerNumber})`;
      if (blNumber) return `(BL# ${blNumber})`;
      if (hblNumber) return `(HBL# ${hblNumber})`;
      if (bookingNumber) return `(BK# ${bookingNumber})`;
      return null;
    }
  }
  
};

export {
  getShipmentNumber,
  getCardType,
  getShipmentType,
  getBulkRequestArray,
  getShipmentIdArray,
};
